import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const TermsService = () => {

  return (
    <div className="termsservice_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/terms-service-bgimg.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Terms of Service</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Terms of Service for CoinViews</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div className="termsservice_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="contntbox">
							<h2>Acceptance of Terms</h2>
							
							<p>By using CoinViews (“the Service”), you agree to comply with these Terms of Service. If you do not accept these Terms, please do not use the Service. We may revise the Terms at any time by updating this page. Your continued use after changes are posted signifies your acceptance of the revised Terms.</p>
							
							<h2>Eligibility</h2>
							
							<p>You must be at least 18 years old and legally able to enter into contracts to use CoinViews. By accessing the Service, you confirm that you meet these criteria.</p>
							
							<h2>Description of Service</h2>
							
							<p>CoinViews aggregates cryptocurrency price information, news stories, airdrop notices, launch‑pad updates, and educational content. We do not provide trading functions, hold digital assets on your behalf, or offer personalized financial guidance. All information is provided “as is” and may not be complete or perfectly current. We reserve the right to modify, suspend, or discontinue any aspect of the Service at any time.</p>
							
							<h2>User Conduct</h2>
							
							<p>You agree not to engage in unlawful or fraudulent activity, including money laundering, while using CoinViews. You must not publish content that misrepresents or defames any person or project. Interference with our systems—such as hacking, spamming, or distributing malware—is prohibited. You may not copy, redistribute, or alter our content without express written consent, nor may you use bots or scraping tools to harvest our data.</p>
							
							<h2>Intellectual Property</h2>
							
							<p>All text, graphics, logos, and code on CoinViews are owned by us or our licensors. We grant you a limited, non‑exclusive, non‑transferable license to access and use the Service for personal, non‑commercial purposes. No other rights are granted.</p>
							
							<h2>Third‑Party Links</h2>
							
							<p>CoinViews may link to external sites such as exchanges or wallet providers. We do not control these sites and are not responsible for their content or services. The presence of a link does not imply endorsement. You access external sites at your own risk.</p>
							
							<h2>Disclaimers and Limitation of Liability</h2>
							
							<p>We make no guarantees about the accuracy, completeness, or reliability of the information provided. The Service is offered “as is” and “as available.” To the maximum extent permitted by law, CoinViews disclaims liability for any losses or damages resulting from your use of, or reliance on, our content. If you are unhappy with the Service, your sole remedy is to cease using it.</p>
							
							<h2>Indemnity</h2>
							
							<p>You agree to indemnify and hold harmless CoinViews and its officers, employees, and partners from any claims, damages, or expenses (including reasonable attorney fees) arising from your use of the Service, your violation of these Terms, or your infringement of any rights of another party.</p>
							
							<h2>Termination</h2>
							
							<p>We may suspend or terminate your access to CoinViews without notice if we believe you have violated these Terms or engaged in harmful conduct. Provisions related to intellectual property, liability limitations, and indemnification remain in effect after termination.</p>
							
							<h2>Governing Law and Dispute Resolution</h2>
							
							<p>These Terms are governed by the laws of India. Any disputes related to the Service will be subject to the exclusive jurisdiction of the courts in Indore, Madhya Pradesh, unless local law requires otherwise.</p>
							
							<h2>Contact</h2>
							
							<p>For questions about these Terms, please email us at <a href="mailto:hello@coinviews.com">hello@coinviews.com</a>.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default TermsService;